import Axios from "./caller.service";

let getPartAccessories = (type) => {
    return Axios.get('api/part_accessories?type='+type)
}

export const partAccessoryService = {
    getPartAccessories
}